{
  "info": "Information",
  "negative": "Fel",
  "notice": "Varning",
  "positive": "Lyckades"
}
